import { forwardRef } from 'react'
import { useViewportSize } from '@mantine/hooks'
import styled from '@emotion/styled'
import DualLangHeader from '../components/DualLangHeader'
import SoundPacks from '../components/SoundPacks'
import { GeneralHeaderText, ColoredSpan, SmallText, Highlight } from '../styles'
import { LearningResourcesSectionWrapper } from '../styles/LearningResourcesSection.styles'

import useMobile from 'src/hooks/useMobile'

const DualLangHeaderText = styled(GeneralHeaderText)` 
  @media (max-width: 594px) { font-size: 2.75rem !important; }
  @media (max-width: 468px) { font-size: 2.25rem !important; }
  @media (max-width: 378px) { text-align: center; font-size: 2rem !important; }
  @media (max-width: 320px) { font-size: 1.75rem !important; }
`

const LearningResourcesSection = (props, ref) => {
  const isMobile = useMobile()

  const { width } = useViewportSize()
  const shouldBreak = width > 814

  return (
    <LearningResourcesSectionWrapper ref={ref}>
      <DualLangHeader otherLang='학습 리소스' blue style={{ padding: '24px 0' }}>
        <DualLangHeaderText>
          Learning <ColoredSpan color='blue'>Resources</ColoredSpan>
        </DualLangHeaderText>
      </DualLangHeader>
      <SmallText isMobile={isMobile} style={{ padding: '0 36px' }}>
        Click any course&apos;s{' '}
        <Highlight>&apos;View&apos;</Highlight>{' '}buttons to explore sounds individually,
        or{' '}
        <Highlight>&apos;Download&apos;</Highlight>
        {shouldBreak ? <br /> : ' '}to get the entire course&apos;s sound pack in a zip file.
      </SmallText>
      <SoundPacks isMobile={isMobile} style={{ margin: '100px 0' }} />
    </LearningResourcesSectionWrapper>
  )
}

export default forwardRef(LearningResourcesSection)
